import { render, staticRenderFns } from "./VbgBuildInfoCardBody.vue?vue&type=template&id=512df0e6&scoped=true"
import script from "./VbgBuildInfoCardBody.vue?vue&type=script&lang=js"
export * from "./VbgBuildInfoCardBody.vue?vue&type=script&lang=js"
import style0 from "./VbgBuildInfoCardBody.vue?vue&type=style&index=0&id=512df0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512df0e6",
  null
  
)

export default component.exports